import Typography from '@components/Typography';
import { Footer as StyledFooter, FooterBottom } from './style';

import type React from 'react';

const date = new Date();

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = (props) => {
  const openUserCentrix = (): void => {
    if (window?.UC_UI?.isInitialized?.()) {
      window.UC_UI.showSecondLayer?.();
    } else {
      window.addEventListener('UC_UI_INITIALIZED', () => {
        window?.UC_UI?.showSecondLayer?.();
      });
    }
  };

  return (
    <StyledFooter {...props}>
      <div className="footer-menu">
        <div className="container menu-container">
          <div className="links">
            <Typography type="H3" className="h3">
              McMakler
            </Typography>
            <div className="contents">
              <div className="left">
                <Typography as="a" href="https://www.mcmakler.de/about-us" type="B2">
                  Über Uns
                </Typography>
                <Typography as="a" href="https://www.mcmakler.de/karriere" type="B2">
                  Karriere
                </Typography>
                <Typography as="a" href="https://www.mcmakler.de/presse" type="B2">
                  Presse
                </Typography>
                <Typography as="a" href="https://www.mcmakler.de/erfahrungen" type="B2">
                  McMakler-Erfahrungen
                </Typography>
                <Typography as="a" href="https://mcmakler-investment.de" type="B2">
                  McMakler Investment
                </Typography>
              </div>
              <div className="right">
                <Typography as="a" href="https://www.mcmakler.de/musterdokumente" type="B2">
                  Musterdokumente
                </Typography>
                <Typography as="a" href="https://www.mcmakler.de/suchagent-fuer-kaeufer" type="B2">
                  Suchauftrag anlegen
                </Typography>
                <Typography as="a" href="https://www.mcmakler.de/auszeichnungen" type="B2">
                  Auszeichnungen
                </Typography>
                <Typography as="a" href="https://www.mcmakler.de/hinweisgebersystem" type="B2">
                  Hinweisgebersystem
                </Typography>
              </div>
            </div>
          </div>
          <div className="contact">
            <Typography type="H3" className="h3">
              Kontakt
            </Typography>
            <div className="contents">
              <div className="left">
                <Typography type="B2" className="label">
                  Kostenlose Service-Hotline
                </Typography>
                <Typography type="H3" className="h3">
                  0800 2002 123
                </Typography>
              </div>
              <div className="right">
                <Typography type="B2" className="label">
                  McMakler E-Mail
                </Typography>
                <Typography type="H3" className="h3">
                  service@mcmakler.de
                </Typography>
              </div>
            </div>
            <Typography type="B2" className="description">
              Wir beraten Sie gerne in einem persönlichen Gespräch am Telefon. Sie erreichen uns von
              Montag bis Freitag von 8:00 – 20:00 Uhr, Sa 9:00 – 18:00 Uhr.
            </Typography>
          </div>
        </div>
      </div>
      <FooterBottom>
        <div className="container">
          <div className="legal-links">
            <Typography type="B2" as="a" href="https://www.mcmakler.de/agb">
              AGB
            </Typography>
            <Typography type="B2" as="a" href="https://www.mcmakler.de/datenschutz">
              Datenschutz
            </Typography>
            <Typography type="B2" as="a" href="https://www.mcmakler.de/impressum">
              Impressum
            </Typography>
            <Typography
              type="B2"
              as="a"
              href="https://a.storyblok.com/f/88871/x/1d10a50833/mcmakler-widerrufsbelehrung-2021.pdf"
            >
              Widerrufsbelehrung
            </Typography>
            <Typography type="B2" as="button" onClick={openUserCentrix} className="primary-flat">
              Cookie Einstellungen
            </Typography>
          </div>
          <div className="copyright">
            <Typography type="B2">&copy; {date.getFullYear()} McMakler GmbH</Typography>
          </div>
        </div>
      </FooterBottom>
    </StyledFooter>
  );
};
